import { CapDoc } from "../capTypes";
import { getCapPackageDoc } from "../constants/capPackageStatus";

const MAX_POLL_ATTEMPTS = 3;
const POLL_RETRY_DELAY_MS = 5000;

const CAP_DOCS_MAY_STILL_BE_UPDATING_MESSAGE =
  "Documents may still be updating. If the agreement looks outdated, refresh the page in a minute.";

const sleep = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });

type PollForUpdatedCapPackageDocArgs = {
  baselineDocId: string;
  maxAttempts?: number;
  refetchCapDocuments: () => Promise<CapDoc[] | undefined>;
  retryDelayMs?: number;
  shouldContinue?: () => boolean;
};

const pollForUpdatedCapPackageDoc = async ({
  baselineDocId,
  maxAttempts = MAX_POLL_ATTEMPTS,
  refetchCapDocuments,
  retryDelayMs = POLL_RETRY_DELAY_MS,
  shouldContinue = () => true,
}: PollForUpdatedCapPackageDocArgs): Promise<boolean> => {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    if (!shouldContinue()) {
      return false;
    }

    const documents = await refetchCapDocuments();
    const currentDocId = getCapPackageDoc(documents)?.documentId;

    if (currentDocId && currentDocId !== baselineDocId) {
      return true;
    }

    if (attempt < maxAttempts - 1) {
      await sleep(retryDelayMs);
    }
  }

  return false;
};

export {
  CAP_DOCS_MAY_STILL_BE_UPDATING_MESSAGE,
  MAX_POLL_ATTEMPTS,
  POLL_RETRY_DELAY_MS,
  pollForUpdatedCapPackageDoc,
};
